import {FormService} from "./form.service";
import {AbstractControl, FormGroup} from "@angular/forms";

export abstract class StandaloneFormService extends FormService {

	static readonly FORM_KEY: string = "STANDALONE_FORM";

	buildStandaloneForm(...args: any[]): FormGroup {
		const form = this.buildFormFor(StandaloneFormService.FORM_KEY, args);
		this.subFormMap[StandaloneFormService.FORM_KEY] = form
		this.markAsInitialized(StandaloneFormService.FORM_KEY, true);
		return form;
	}

	override buildSubForm(formKey: string, totalSubForms: number, ...args: any[]): FormGroup {
		throw new Error("Unsupported");
	}

	isPristine(): boolean {
		return super.isSubFormPristine(StandaloneFormService.FORM_KEY);
	}

	override getFormControl(formKey: string, ...path: string[]): AbstractControl {
		return <AbstractControl<any, any>> this.getForm(formKey).get(path);
	}
}
